import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import CustomModal from "../CustomModal/CustomModal";
import { Section } from "../CustomLayout/CustomLayoutStyles";
import CustomInput from "../CustomForm/CustomInput";
import CustomButton from "../CustomButton/CustomButton";
import CustomSeparator from "../Common/CustomSeparator";
import Text from "../Common/Text";
import { SaveOutlined, CloseOutlined } from "@ant-design/icons";
import Colors from "../../themes/Colors";
import PrestadorService from "../../services/prestador/PrestadorService";
import AuthActions from "../../stores/auth/Actions";
import {
  ModalHeader,
  ModalContent,
  FieldRow,
  ButtonContainer,
} from "./ModalInformacionPrestadorStyles";

const ModalInformacionPrestador = ({ isOpen, onClose, prestador, updatePrestadorCorreo }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [correoElectronico, setCorreoElectronico] = useState(
    prestador?.correoElectronico || ""
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (prestador?.correoElectronico) {
      setCorreoElectronico(prestador.correoElectronico);
    }
  }, [prestador?.correoElectronico]);

  const handleEdit = useCallback(() => {
    setIsEditing(true);
    setError("");
  }, []);

  const handleCancel = useCallback(() => {
    setIsEditing(false);
    setCorreoElectronico(prestador?.correoElectronico || "");
    setError("");
  }, [prestador]);

  const handleSave = useCallback(async () => {
    if (!correoElectronico || correoElectronico.trim() === "") {
      setError("El correo electrónico es obligatorio");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(correoElectronico)) {
      setError("El correo electrónico no tiene un formato válido");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const request = {
        requestData: {
          correo: correoElectronico,
          comentario: "Actualización de correo electrónico desde WebSalud",
        },
        requestHeaders: {},
      };

      await PrestadorService.actualizarCorreoPrestador(request);
      updatePrestadorCorreo(correoElectronico);
      setIsEditing(false);
      onClose();
    } catch (err) {
      setError(
        err?.response?.data?.mensaje ||
        err?.message ||
        "Error al actualizar el correo electrónico"
      );
    } finally {
      setIsLoading(false);
    }
  }, [correoElectronico, onClose, updatePrestadorCorreo]);

  const handleClose = useCallback(() => {
    if (!isEditing) {
      onClose();
    }
  }, [isEditing, onClose]);

  return (
    <CustomModal isOpen={isOpen} onClose={handleClose} maxWidth="600px">
      <Section flexDirection="column" padding="20px">
        <ModalHeader>
          <Text size="20px" weight="bold" >
            Información del Prestador
          </Text>
        </ModalHeader>

        <ModalContent>
          <FieldRow>
            <CustomInput
              type="email"
              label="Correo Electrónico"
              value={correoElectronico}
              onChange={setCorreoElectronico}
              disabled={!isEditing}
              width="100%"
              required={isEditing}
            />
          </FieldRow>

          <CustomSeparator height={"15px"} />

          <FieldRow>
            <CustomInput
              type="text"
              label="Celular"
              value={prestador?.celular || "N/A"}
              disabled={true}
              width="100%"
            />
          </FieldRow>

          <CustomSeparator height={"15px"} />

          <FieldRow>
            <CustomInput
              type="text"
              label="Teléfono"
              value={prestador?.telefono || "N/A"}
              disabled={true}
              width="100%"
            />
          </FieldRow>

          <CustomSeparator height={"15px"} />

          <FieldRow>
            <CustomInput
              type="text"
              label="Teléfono Otro"
              value={prestador?.telefonoOtro || "N/A"}
              disabled={true}
              width="100%"
            />
          </FieldRow>

          {error && (
            <>
              <CustomSeparator height={"10px"} />
              <Text size="12px" color="red">
                {error}
              </Text>
            </>
          )}

          <CustomSeparator height={"20px"} />

          {isEditing ? (
            <ButtonContainer>
              <CustomButton
                label="Cancelar"
                onClick={handleCancel}
                disabled={isLoading}
                width="120px"
                height="40px"
                bgColor={Colors.grey}
                hoverColor={Colors.darkGray}
                icon={<CloseOutlined />}
              />
              <CustomButton
                label="Guardar"
                onClick={handleSave}
                isLoading={isLoading}
                disabled={isLoading}
                width="120px"
                height="40px"
                icon={<SaveOutlined />}
              />
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <CustomButton
                label="Editar"
                onClick={handleEdit}
                width="120px"
                height="40px"
              />
            </ButtonContainer>
          )}
        </ModalContent>
      </Section>
    </CustomModal>
  );
};

const mapDispatchToProps = {
  updatePrestadorCorreo: AuthActions.updatePrestadorCorreo,
};

const connector = connect(null, mapDispatchToProps);

export default connector(ModalInformacionPrestador);

